import commercialPrintApi from '@/api/v1/commercialPrint';

export default {
  namespaced: true,

  state: {
    commercialPrintList: [],
  },

  mutations: {
    SET_COMMERCIAL_PRINT(state, items) {
      state.commercialPrintList = items;
    },

    REMOVE_COMMERCIAL_PRINT(state) {
      state.commercialPrintList = [];
    },
  },

  actions: {
    fetchCommercialPrint({ commit, rootState }) {
      commit('CHANGE_LOADING_STATUS', true, { root: true });

      const { selectedFilters } = rootState.filters;
      const { itemsPerPage, pagination } = rootState.pagination;

      const params = {
        page: pagination.page,
        itemsPerPage,
        filters: selectedFilters,
      };

      commercialPrintApi
        .index(params)
        .then((resp) => {
          commit('pagination/SET_PAGINATION', resp.data.pagination, {
            root: true,
          });
          commit('SET_COMMERCIAL_PRINT', resp.data.collection);
        })
        .finally(() => {
          commit('CHANGE_LOADING_STATUS', false, { root: true });
        });
    },

    resetCommercialPrint({ commit, dispatch }) {
      commit('REMOVE_COMMERCIAL_PRINT');
      dispatch('filters/clearFilters', null, { root: true });
      dispatch('pagination/resetPagination', null, { root: true });
    },
  },
};
